import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '热门推荐', path: '/category?filter=hot' },
  { label: '最新更新', path: '/category?filter=latest' },
  { label: '完结漫画', path: '/category?filter=completed' },
  { label: '韩漫专区', path: '/category?type=korean' },
  { label: '日漫专区', path: '/category?type=japanese' },
  { label: '国漫专区', path: '/category?type=chinese' },
];

const genreLinks = [
  { label: '热血漫画', path: '/category?type=action' },
  { label: '恋爱漫画', path: '/category?type=romance' },
  { label: '奇幻漫画', path: '/category?type=fantasy' },
  { label: '悬疑漫画', path: '/category?type=mystery' },
  { label: '搞笑漫画', path: '/category?type=comedy' },
  { label: '都市漫画', path: '/category?type=urban' },
];

export default function Footer() {
  const handleNewsletterSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('website_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      const msgEl = document.getElementById('newsletter-msg');
      if (msgEl) {
        msgEl.textContent = '感谢订阅！您将第一时间收到最新漫画更新通知。';
        msgEl.className = 'text-sm text-primary-600 mt-2';
      }
      form.reset();
      return;
    }
    // Form submission would go here with get_form_url
    const msgEl = document.getElementById('newsletter-msg');
    if (msgEl) {
      msgEl.textContent = '感谢订阅！您将第一时间收到最新漫画更新通知。';
      msgEl.className = 'text-sm text-primary-600 mt-2';
    }
    form.reset();
  };

  return (
    <footer className="bg-foreground-900 text-foreground-200">
      {/* Main Footer */}
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            {/* Brand Column */}
            <div className="sm:col-span-2 lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-book-open-line text-lg text-white"></i>
                </div>
                <span className="font-heading font-bold text-xl text-white whitespace-nowrap">
                  奇妙漫画
                </span>
              </div>
              <p className="text-sm leading-relaxed text-foreground-300 mb-5">
                汇集海量韩漫、日漫、国漫资源，热门推荐漫画免费全集在线看，支持下拉式连续阅读。做最懂你的漫画阅读平台。
              </p>
              {/* Newsletter */}
              <div>
                <p className="text-sm font-medium text-white mb-3">订阅更新通知</p>
                <form onSubmit={handleNewsletterSubmit} className="flex flex-col sm:flex-row gap-2" action="https://readdy.ai/api/form/d9oo8caqs38sj6jc7ceg" method="POST" data-readdy-form="">
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="输入您的邮箱"
                    className="flex-1 h-9 px-4 rounded-lg text-sm bg-foreground-800 border border-foreground-700 text-white placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
                  />
                  <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                  <button
                    type="submit"
                    className="h-9 px-5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-lg transition-colors whitespace-nowrap"
                  >
                    订阅
                  </button>
                </form>
                <div id="newsletter-msg"></div>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-heading font-semibold text-white text-sm mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                {quickLinks.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Genre Links */}
            <div>
              <h4 className="font-heading font-semibold text-white text-sm mb-4">漫画类型</h4>
              <ul className="space-y-2.5">
                {genreLinks.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Column */}
            <div>
              <h4 className="font-heading font-semibold text-white text-sm mb-4">联系我们</h4>
              <ul className="space-y-3">
                <li>
                  <a href="mailto:contact@qimiaomanhua.com" className="flex items-center gap-2 text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                    <i className="ri-mail-line text-base w-5 h-5 flex items-center justify-center"></i>
                    contact@qimiaomanhua.com
                  </a>
                </li>
                <li>
                  <a href="https://weibo.com" target="_blank" rel="nofollow noopener noreferrer" className="flex items-center gap-2 text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                    <i className="ri-weibo-line text-base w-5 h-5 flex items-center justify-center"></i>
                    新浪微博
                  </a>
                </li>
                <li>
                  <a href="https://www.xiaohongshu.com" target="_blank" rel="nofollow noopener noreferrer" className="flex items-center gap-2 text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                    <i className="ri-red-packet-line text-base w-5 h-5 flex items-center justify-center"></i>
                    小红书
                  </a>
                </li>
                <li>
                  <span className="flex items-center gap-2 text-sm text-foreground-300">
                    <i className="ri-customer-service-2-line text-base w-5 h-5 flex items-center justify-center"></i>
                    客服微信: qimiaomh
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="border-t border-foreground-800">
        <div className="w-full px-4 md:px-6 py-5">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; 2024 - 2026 奇妙漫画 qimiaomanhua.com 版权所有 | 
              <a href="#" className="hover:text-primary-400 transition-colors ml-1">京ICP备2024XXXXXXXX号</a>
            </p>
            <div className="flex items-center gap-4">
              <Link to="/about" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors">关于我们</Link>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors">隐私政策</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors">用户协议</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}